export default function init() {
	class CTA {
		static CLASS_NAME_IMG_SQUARE = 'jtf__ctablock--img-square'
		static CLASS_NAME_CENTRE = 'jtf__ctablock--centre'
		static SELECTOR_CLASS_IMG_SQUARE = '.jtf__ctablock--img-square'
		static SELECTOR_CLASS_CENTRE = '.jtf__ctablock--centre'
		static SELECTOR_CLASS_BLOCK = '.wp-block-jtf-jtf-cta'
		static TIMEOUT_DELAY = 1000

		constructor( instance ) {
			this.instance = instance
			this.init()
		}

		resizeOnWindowChange() {
			const images = this.instance.querySelectorAll( CTA.SELECTOR_CLASS_IMG_SQUARE )
			images.forEach( ( img ) => {
				if ( !img.closest( CTA.SELECTOR_CLASS_CENTRE ) ) {
					const thisWidth = img.offsetWidth
					img.style.height = `${thisWidth}px`
				}
			} )
		}

		init() {
			this.resizeOnWindowChange()
			window.addEventListener( 'resize', () => {
				this.resizeOnWindowChange()
			} )
		}
	}

	setTimeout( () => {
		const blocks = document.querySelectorAll( CTA.SELECTOR_CLASS_BLOCK )
		if ( blocks.length > 0 ) {
			blocks.forEach( ( block ) => {
				new CTA( block )
			} )
		}
	}, CTA.TIMEOUT_DELAY )
}
